import styled from "styled-components";

export const Page = styled.div`
  padding: 0px 30px;
  margin-top: 20px;
  display: flex;
  flex-direction: column;

  header {
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: ${({ theme }) => theme.colors.secondary70};
    span {
      display: flex;
      align-items: flex-start;
      font-weight: 600;
      color: ${({ theme }) => theme.colors.secondary100};
    }
  }
  .search {
    cursor: pointer;
    margin-top: 30px;
    border-radius: 8px;
    background-color: ${({ theme }) => theme.colors.secondary10};
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 45px;
    height: 45px;
    border-radius: 8px;
    align-self: end;
    transition: width 0.4s;
    padding: 11px;

    svg {
      color: ${({ theme }) => theme.colors.secondary100};
      width: 25px;
      height: 25px;
    }
    input {
      display: none;
      margin-right: 8px;
      width: 100%;
      background: transparent;
    }
  }
  .active {
    padding: 14px;
    width: 400px;
    justify-content: end;
    input {
      display: block;
    }
  }
  .content {
    padding: 20px;
    position: relative;
    width: 100%;
    min-height: 200px;
    max-height: 600px;
    background-color: ${({ theme }) => theme.colors.secondary10};
    border-radius: 8px;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
    margin-top: 7px;
    margin-bottom: 30px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: auto;
    .loading {
      width: 100%;
      height: 200px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    table {
      width: 100%;
      font-size: 16px;
      font-weight: 500;
      color: ${({ theme }) => theme.colors.secondary100};
      text-align: left;
      table-layout: fixed;
      margin-bottom: 15px;

      th {
        font-weight: 600;
      }
      td {
        text-transform: capitalize;
        margin-bottom: 8px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        svg {
          cursor: pointer;
        }
      }
    }
  }
`;
export const UserActions = styled.ul`
  background-color: ${({ theme }) => theme.colors.secondary10};
  border-radius: 8px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
  padding: 12px;
  color: ${({ theme }) => theme.colors.secondary100};
  li {
    cursor: pointer;
    display: flex;
    align-items: center;
    margin: 5px 0px;
    font-size: 16px;
    svg {
      margin-right: 5px;
      width: 20px;
      height: 20px;
    }
  }
`;
export const ModalInputs = styled.div``;
